<template>
  <div class="first-word">
    {{firstLetter}}
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
    export default {
        name: "firstLetter",
      computed: {
        ...mapGetters(['userInfo']),
        firstLetter(){
          return this.userInfo.username.toUpperCase().charAt(0);
        }
      },
    }
</script>

<style scoped>
  .first-word {
    width: 40px;
    height: 40px;
    background-color: #cccccc;
    border-radius: 50%;
    color: #ffffff;
    height: 40px;
    line-height: 40px;
  }
</style>
